module.exports = __webpack_public_path__ + "img/dracula-19.0e18d3bb.jpg";